import {
  adaptedToEquipement,
  equipementToAdapted,
  equipementsToAdapted,
} from "../../adapter/equipementAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_EQUIPEMENTS = "LOAD_EQUIPEMENTS";
export const LOAD_SUCCESS_EQUIPEMENTS = "LOAD_SUCCESS_EQUIPEMENTS";
export const LOAD_FAIL_EQUIPEMENTS = "LOAD_FAIL_EQUIPEMENTS";
export const SAVE_SUCCESS_EQUIPEMENTS = "SAVE_SUCCESS_EQUIPEMENTS";
export const SAVE_FAIL_EQUIPEMENTS = "SAVE_FAIL_EQUIPEMENTS";
export const UPDATE_SUCCESS_EQUIPEMENTS = "UPDATE_SUCCESS_EQUIPEMENTS";
export const UPDATE_FAIL_EQUIPEMENTS = "UPDATE_FAIL_EQUIPEMENTS";
export const DELETE_SUCCESS_EQUIPEMENTS = "DELETE_SUCCESS_EQUIPEMENTS";
export const DELETE_FAIL_EQUIPEMENTS = "DELETE_FAIL_EQUIPEMENTS";

export function loadEquipements() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`equipements`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.equipement);
          dispatch({
            type: LOAD_SUCCESS_EQUIPEMENTS,
            payload: equipementsToAdapted(res.equipement),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_EQUIPEMENTS,
            error: err,
          });
        });
    });
  };
}

export function saveEquipement(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`equipements`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToEquipement(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.equipement);
          dispatch({
            type: SAVE_SUCCESS_EQUIPEMENTS,
            payload: equipementToAdapted(res.equipement),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_EQUIPEMENTS,
            error: err,
          })
        );
    });
  };
}

export function updateEquipement(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`equipements/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToEquipement(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.equipement);
          dispatch({
            type: UPDATE_SUCCESS_EQUIPEMENTS,
            payload: equipementToAdapted(res.equipement),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_EQUIPEMENTS,
            error: err,
          })
        );
    });
  };
}

export function deleteEquipement(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`equipements/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.equipement);
          dispatch({
            type: DELETE_SUCCESS_EQUIPEMENTS,
            payload: equipementToAdapted(res.equipement),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_EQUIPEMENTS,
            error: err,
          });
        });
    });
  };
}
